module.exports = __webpack_public_path__ + "img/Yearn Consulting Group.0e9aaa8e.svg";